<template>
  <v-container
    id="time-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <dashboard-filtro-datas
          :primeiro="enablePrimeiroDia"
          :ultimo="enableUltimoDia"
          :empresas="enableEmpresa"
          :supervisores="enableSupervisor"
          :receitas="enableReceita"
          :segmentos="enableSegmento"
          :classificacoes="enableClassificacao"
          :vendedores="enableVendedor"
          :habilitar-filtros-data="enableFiltrosDados"
          :url="link"
        />
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
              :max-width="width"
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Como está o meu time?
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconTime3"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('154')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="!carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <show-evolucao-supervisor-time id="evolucaoTime" />
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            id="componenteTime"
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
              :max-width="width"
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Qual minha evolução de vendas?
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconTime3"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('144')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="!carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <show-evolucao-supervisor-vendas />
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            id="componenteTime"
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
              :max-width="width"
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    E referente a evolução em volume de venda?
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconTime3"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('145')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="!carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <show-evolucao-volume-vendas />
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            id="componenteTime"
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
              :max-width="width"
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Cobertura Vendedor
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconTime3"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('345')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="!carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <show-table-cobertura-vendedores />
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            id="componenteTime"
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-row id="textoMetaPeriodoTime">
              <v-col
                cols="12"
                sm="12"
                md="6"
                lg="6"
              >
                <v-card
                  id="cardDashbord"
                  class="mx-auto"
                  outlined
                  :max-width="width"
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        Quanto atingimos da meta no período?
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                        class="d-flex justify-end"
                      >
                        <v-tooltip
                          top
                          max-width="400"
                          width="400"
                        >
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-icon
                              id="iconTime3"
                              class="text-left"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="enableTexto('155')"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div
                            v-if="!carregandoTooltip"
                            v-html="textoOrientacao"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <dashboard-atigimento-meta-periodo />
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="6"
                lg="6"
              >
                <v-card
                  id="cardDashbord"
                  class="mx-auto"
                  outlined
                  :max-width="width"
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        Qual a distribuição geográfica dos meus supervisores?
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                        class="d-flex justify-end"
                      >
                        <v-tooltip
                          top
                          max-width="400"
                          width="400"
                        >
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-icon
                              id="iconTime3"
                              class="text-left"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="enableTexto('156')"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div
                            v-if="!carregandoTooltip"
                            v-html="textoOrientacao"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <br>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <dashboard-maps-time />
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-row id="textoMetaPeriodoTime">
              <v-col
                id="componenteTime"
                cols="12"
                sm="12"
                md="6"
                lg="6"
              >
                <v-card
                  id="cardDashbord"
                  class="mx-auto"
                  outlined
                  :max-width="width"
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        Qual é o ticket médio por supervisor?
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                        class="d-flex justify-end"
                      >
                        <v-tooltip
                          top
                          max-width="400"
                          width="400"
                        >
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-icon
                              id="iconTime3"
                              class="text-left"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="enableTexto('157')"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div
                            v-if="!carregandoTooltip"
                            v-html="textoOrientacao"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <dashoboard-ticket-medio-supervisor />
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <v-col
                id="componenteTime"
                cols="12"
                sm="12"
                md="6"
                lg="6"
              >
                <v-card
                  id="cardDashbord"
                  class="mx-auto"
                  outlined
                  :max-width="width"
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        Como está meu supervisor comparado com a empresa?
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                        class="d-flex justify-end"
                      >
                        <v-tooltip
                          top
                          max-width="400"
                          width="400"
                        >
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-icon
                              id="iconTime3"
                              class="text-left"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="enableTexto('158')"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div
                            v-if="!carregandoTooltip"
                            v-html="textoOrientacao"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <dashoboard-ticket-supervisor-empresa />
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'PageTime',
    emits: ['updateTime', 'updateProgressoTime', 'updateLocalizcao', 'updateTicket', 'enableFaturamento', 'disableLoading', 'disableLoadingGrafico', 'updateComparativoFaturamento', 'atualizarTexto'],
    components: {
      DashboardFiltroDatas: () => import('../../components/core/FiltroDatas'),
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      ShowEvolucaoSupervisorTime: () => import('../../components/comercial/time3/Time3EvolucaoSupervisor'),
      ShowEvolucaoSupervisorVendas: () => import('../../components/comercial/time3/FaturamentoEvolucaoSupervisorTime3'),
      ShowEvolucaoVolumeVendas: () => import('../../components/comercial/time/FaturamentoEvolucaoVolumeTime'),
      showTableCoberturaVendedores: () => import('../../components/comercial/time3/Time3TableCoberturaVendedores'),
      DashboardAtigimentoMetaPeriodo: () => import('../../graficos/Time/AtigimentoMetaPeriodo'),
      DashboardMapsTime: () => import('../../maps/Time/DashboardMapsTime'),
      DashoboardTicketMedioSupervisor: () => import('../../graficos/Time/TicketMedioSupervisor'),
      DashoboardTicketSupervisorEmpresa: () => import('../../graficos/Time/TicketSupervisorEmpresa'),
    },
    mixins: [utils],
    data: () => ({
      attrs: '',
      on: '',
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      usuarioIdentificado: false,
      permissaoTime: '',
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dateFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      select: [],
      empresa: [],
      supervisor: [],
      receita: [],
      segmento: [],
      areas: [],
      redes: [],
      classificacao: [],
      vendedores: [],
      codigo: 0,
      orientacao: [],
      codigoIds: ['144', '145', '154', '155', '156', '157', '158', '345', '361'],
      textoMeuTime: '',
      textoAtigimentoMeta: '',
      textoDistribuicaoTime: '',
      textoTicketMedioTime: '',
      textoSupervisorTimte: '',
      textoFatEvolucaoVendas: '',
      textoVolumeEvolucaoVendas: '',
      textoCoberturaVendedor: '',
      textoComparativoFaturamento: '',
      paginaEnable: false,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableSupervisor: true,
      enableReceita: true,
      enableSegmento: true,
      enableClassificacao: true,
      enableVendedor: true,
      enableFiltrosDados: false,
      link: window.location.href,
      chartMedioSupervisor: {},
      legendaMedioSupervisor: [],
      dynamicPaddingTime1: '',
      dynamicPaddingTime2: '',
      dynamicPaddingTime3: '',
      width: '',
      vendedor: [],
      vendedorSelect: [],
      selectVendedor: [],
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },

      computedPrimeiroDia () {
        return this.formatDate(this.primeiroDia)
      },
    },

    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Time')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        // localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingTime1 = 'padding-right: 104rem !important'

          this.dynamicPaddingTime2 = 'padding-right: 38.4rem !important'

          this.dynamicPaddingTime3 = 'padding-right: 35rem !important'

          this.dynamicPaddingTime4 = 'padding-right: 35rem !important'

          this.width = ''
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingTime1 = 'padding-right: 65rem !important'

          this.dynamicPaddingTime2 = 'padding-right: 17.8rem !important'

          this.dynamicPaddingTime3 = 'padding-right: 17rem !important'

          this.dynamicPaddingTime4 = 'padding-right: 15rem !important'

          this.width = ''
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingTime1 = 'padding-right: 4rem !important'

          this.dynamicPaddingTime2 = 'padding-right: 4rem !important'

          this.dynamicPaddingTime3 = 'padding-right: 4rem !important'

          this.dynamicPaddingTime4 = 'padding-right: 4rem !important'

          this.width = '370'
        } else if (window.innerWidth > 601 && window.innerWidth < 1000) {
          this.dynamicPaddingTime1 = 'padding-right: 25rem !important'

          this.dynamicPaddingTime2 = 'padding-right: 25rem !important'

          this.dynamicPaddingTime3 = 'padding-right: 25rem !important'

          this.dynamicPaddingTime4 = 'padding-right: 25rem !important'

          this.width = ''
        } else {
          this.dynamicPaddingTime1 = 'padding-right: 60rem !important'

          this.dynamicPaddingTime2 = 'padding-right: 16.5rem !important'

          this.dynamicPaddingTime3 = 'padding-right: 13rem !important'

          this.dynamicPaddingTime4 = 'padding-right: 13rem !important'

          this.width = ''
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, areas, redes, supervisores, receita, segmento, classificacao, produto, cidade, categoria, promotor, linhasProducao) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.supervisor = supervisores
        this.receita = receita
        this.segmento = segmento
        this.classificacao = classificacao
        this.vendedores = vendedores
        this.vendedorSelect = []
        this.selectVendedor = []

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('empresaId', JSON.stringify(this.select || []))
        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.date)

        this.updateDate()
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      async updateDate () {
        eventEmit.$emit('update-localizcao', this.primeiroDia, this.date, this.select, this.supervisor, this.receita, this.segmento, [], [], [], this.classificacao, this.vendedores)
        eventEmit.$emit('update-ticket', this.primeiroDia, this.date, this.select, this.supervisor, this.receita, this.segmento, [], [], [], this.classificacao, this.vendedores)
        eventEmit.$emit('update-time', this.primeiroDia, this.date, this.select, this.supervisor, this.receita, this.segmento, [], [], [], this.classificacao, this.vendedores)
        eventEmit.$emit('update-comparativo-faturamento', this.select, this.supervisor, this.selectVendedor, this.areas, this.redes, this.receita, this.segmento, [], [], this.classificacao, this.vendedores)
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      handleSelectVendedor () {
        this.selectVendedor = []

        this.selectVendedor = [this.vendedorSelect]
      },

      updateComparativoVendedor () {
        eventEmit.$emit('update-comparativo-faturamento', this.select, this.supervisor, this.selectVendedor, this.areas, this.redes, this.receita, this.segmento, [], [], this.classificacao, this.vendedores)
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>

  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    #btnRefazerVendas {
      font-size: 10px;
      margin-top: 2rem;
      margin-left: -1.4rem;
    }

    #iconTime3 {
      margin: -5rem 0 0 0;
    }

    .container {
      display: flex;
      flex-wrap: wrap;
    }

    .cell {
      display: flex;
      align-items: center;
      height: 100px;
    }

    #iconInformationMeuTime {
      margin: 0 0 0 -0.5rem;
    }
  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #iconInformationMeuTime {
      margin: 0 0 0 -0.5rem;
    }
  }
</style>

<style lang="sass">
  #meuTime
    margin: -1rem 0 -1rem -0.3rem

  #iconInformationMeuTime
    margin: 0rem 0 0 4.5rem

  #statusUltimosMeses
    margin: -1rem 0 0.2rem 2rem

  .container
    max-width: 100%

  #textoEvolucaoVendaTime
    margin: 0 0 0 1rem

  #iconInformationAcumuladoAnualTime
    margin: 0 0 0 5rem

  #divisaId
    // margin: 10rem 0 0 0

  #listItemEvolucaoTime
    margin: -2rem 0 0 -1rem

  #componenteTime
    margin: -2rem 0 0 0rem

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemAtingimentoMeta
    margin: -2rem 0 0 -1rem

  #listItemMapsTime
    margin: -2rem 0 0 -1rem

  #listItemMedioSupervisor
    margin: -2rem 0 0 -1rem

</style>
